module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "pagexiii"
    }
  }, [_c('h2', {
    staticClass: "chap-title"
  }, [_vm._v("A Note on Sources")]), _vm._v(" "), _c('p', {
    staticClass: "foot1"
  })]), _c('div', {
    staticClass: "block-quote"
  }, [_c('a', {
    attrs: {
      "id": "pagexiii"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The details of Temüjin’s … rise to chief of the Mongol tribe are told in the Secret History of the Mongols, the Shengwu Qinzheng Lu, and in Rashid-ud-Din’s COMPENDIUM OF CHRONICLES. While often sharing episodes, they also diverge on many points, particularly chronology, and it is difficult, if not impossible, to reconstruct a synoptic narrative of his political vicissitudes before 1201.’")])]), _c('p', {
    staticClass: "noindent-t1"
  }, [_c('a', {
    attrs: {
      "id": "pagexiii"
    }
  }, [_vm._v("– Christopher Atwood"), _c('span', {
    staticClass: "super"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/#note10",
      "id": "footnote10"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The important sources for the rise of the Mongols are the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Shengwujinzhenglu")]), _vm._v(" (SWQZL), the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yuanshi")]), _vm._v(", Rashid al-Din’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Compendium of Chronicles")]), _vm._v(", and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Secret History.")]), _vm._v(" Of these the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Secret History")]), _vm._v(" is generally considered to be the earliest, with the other sources compiled somewhat later. They all appear to draw on common sources, with the SWQZL, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yuanshi")]), _vm._v(" and Rashid al-Din in particular being very closely related to each other. The two former, both Chinese chronicles, are shorter and crafted in the tradition of dynastic histories. This means having quite an economical account, leaving out non-essential information, and also to be respectful to the man with ‘the Mandate of Heaven’. In some parts there is also a clear link between the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Secret History")]), _vm._v(" and the other sources.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Secret History:")]), _vm._v(" The most well known early source, at least in the West, is the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Secret History.")]), _vm._v(" It is in the style of an epic, and draws on oral traditions. Many episodes are described in great detail, but it is a selective account which fails to cover all events. This is clear, for example, from its short treatment of the early Xia or Jin campaigns (between 1205 and 1215). It also seems that the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Secret History")]), _vm._v(" sometimes modifies events to build dramatic tension. On the positive side, the author is quite ready to be honest, in several places clearly saying some negative things about Genghis Khan. Clearly the overall chronology has somehow been mixed up, perhaps in part due to careless editing. The work may have been updated as late as c.1252, but the bulk of the material seems to have been compiled much earlier. Igor de Rachewiltz translated and provided a detailed commentary of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Secret History."), _c('span', {
    staticClass: "super"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#note11",
      "id": "footnote11"
    }
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pagexiv"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Shengwujinzhenglu:")]), _vm._v(" The best overall early source is arguably the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Shengwujinzhenglu")]), _vm._v(" (SWQZL). It is a more comprehensive source than the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Secret History")]), _vm._v(" with regard to headline events covered and has a much more disciplined chronology. It is polite – it will not say that Genghis Khan was defeated – and does have some possible errors. The source loses quality once the focus shifts into China. The SWQZL places Samuqa’s Henan raid in 1215, a year too early, and says the Jin emperor left Kaifeng in September 1231, three months too early. Almost nothing is said about the final Xia campaigns during which Temüjin died. The SWQZL has been translated and annotated by Pelliot and Hambis up to the year 1201 in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Histoire des campagnes de Gengis Khan – Chen-wou ts’in-tcheng lou.")]), _vm._v(" John Emerson continued this work, adding 1202 and 1203. Erich Haenisch translated the years 1219–1227 in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Die letzen Feldzüge Cinggis Han’s und sein Tod."), _c('span', {
    staticClass: "super"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#note12",
      "id": "footnote12"
    }
  }, [_vm._v("3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Yuanshi:")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yuanshi")]), _vm._v(" is the official dynastic history of the Mongol ruling house in China, finalised around 1370 during the Ming dynasty. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yuanshi")]), _vm._v(" base annals ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yuanshi")]), _vm._v(" 1) are close to the SWQZL, but are generally more condensed. It does have details on the campaigns against Xia not found in the SWQZL. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yuanshi")]), _vm._v(" as a whole seems to be edited somewhat poorly (it has been said it is the worst edited of any of the 24 Chinese dynastic histories). For example, Sübe’etei has two biographies with different spellings of his name. Eight other non-Han Chinese also have two biographies. Temüjin’s march against the Merkits in 1198 is misplaced, and names and places where fighting took place against the Jin in 1211, 1212, and 1213 are duplicated. A wealth of detail about the campaigns in China and the Western regions is found in the biographies."), _c('span', {
    staticClass: "super"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#note13",
      "id": "footnote13"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Collected Chronicles:")]), _vm._v(" The Persian historian Rashid al-Din used similar sources as the SWQZL and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yuanshi")]), _vm._v(", but made a more extensive commentary. Rashid al-Din’s understanding of geography outside the Middle East was poor. For events in China, where geographical understanding is important, his work is of less value. Thackston has made an excellent translation with a lot of effort to match names to those known from "), _c('a', {
    attrs: {
      "id": "pagexv"
    }
  }, [_vm._v("Mongolian and Chinese sources."), _c('span', {
    staticClass: "super"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/#note14",
      "id": "footnote14"
    }
  }, [_vm._v("5")]), _vm._v(" Before Thackston, the only European translation was in Russian.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For the later period, only the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yuanshi")]), _vm._v(" and Rashid al-Din’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Collected Chronicles")]), _vm._v(" remain important. For Genghis Khan, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yuanshi")]), _vm._v(" 1 is most important. For the later period, in addition to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yuanshi")]), _vm._v(" 2, much valuable information can be gained from the many biographies. Other important sources are the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jinshi")]), _vm._v(", the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Songshi")]), _vm._v(", Juvaini, ibn al-Athir, Nasawi, Juzjani, and the Georgian, Rus, and Central European chronicles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Jinshi:")]), _vm._v(" The dynastic history of the Jin dynasty (compiled 1268–1343, during the Mongol Yuan dynasty) is much better edited than the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yuanshi.")]), _vm._v(" The base annals are not very detailed, but a wealth of detail is provided in the many biographies of the various military men. Many events can be followed on a day-to-day basis. In particular "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jinshi")]), _vm._v(" 112 is vital for the 1231–1232 campaign."), _c('span', {
    staticClass: "super"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#note15",
      "id": "footnote15"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Songshi:")]), _vm._v(" The dynastic history of the Song dynasty (written like the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jinshi")]), _vm._v(" during the later years of the Yuan dynasty) is not all as effectively edited, as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jinshi")]), _vm._v(", but it is vast in scope. The compilers had access to many diaries and other contemporary records. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Songshi")]), _vm._v(" is especially noted for the high quality of its biographies. Much other Song literature is preserved in addition to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Songshi.")]), _vm._v(" Other early Chinese sources include accounts of Song officials going to meet the Mongols as well as Mi Zhou’s eyewitness description of the 1234 campaign."), _c('span', {
    staticClass: "super"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#note16",
      "id": "footnote16"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Wang Yun")]), _vm._v(" wrote a biography about Sübe’etei and his family. He was a contemporary of Sübe’etei’s grandson Aju. This work is related to the two "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yuanshi")]), _vm._v(" biographies."), _c('span', {
    staticClass: "super"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#note17",
      "id": "footnote17"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Juvaini:")]), _vm._v(" A Persian civil servant in Mongol Iran who wrote a history c.1260, Juvaini is especially well informed about events in and around Transoxiana and Khorasan. Rashid al-Din made use of his work."), _c('span', {
    staticClass: "super"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#note18",
      "id": "footnote18"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ibn al-Athir:")]), _vm._v(" A contemporary (died in 1233) based in Mosul, Ibn al-Athir wrote a history of the world vast in scope. He is certainly well informed about events close to his hometown. For events further away he drew on Muslim traders and travellers as well as other people he met. The Mongol defeat of the Bulgars in 1224 is alluded to in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Secret History")]), _vm._v(", but only Ibn al-Athir provides details on this. Rashid al-Din relied on Ibn al-Athir for some sections of his work."), _c('span', {
    staticClass: "super"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#note19",
      "id": "footnote19"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Nasawi:")]), _vm._v(" Shihab al-Din Muhammad al-Nasawi (died c.1250) was another contemporary who later wrote a history (around 1241). He was close to Jalal al-Din "), _c('a', {
    attrs: {
      "id": "pagexvi"
    }
  }, [_vm._v("and hostile towards the Mongols. He wrote an account of the eventful life of Jalal al-Din."), _c('span', {
    staticClass: "super"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/#note20",
      "id": "footnote20"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Juzjani:")]), _vm._v(" Minhaj al-Siraj Juzjani (born 1193) experienced the Mongol attack on Khwarezm first-hand and wrote what is at times a very detailed narrative of events. He is hostile towards the Mongols, providing balance to Juvaini and Rashid al-Din. He is best informed about events in what is now Afghanistan and Pakistan."), _c('span', {
    staticClass: "super"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#note21",
      "id": "footnote21"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Georgian/Armenian Chronicles:")]), _vm._v(" Written some decades after the events, Grigor Aknerc’i, Kirakos Ganjakec’i, Vardan Arewelc’I, and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The History of Kart’li")]), _vm._v(" still has much to offer on the Mongol invasion of Georgia in 1221."), _c('span', {
    staticClass: "super"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#note22",
      "id": "footnote22"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Rus Chronicles:")]), _vm._v(" The early chronicles are "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Chronicle of Novgorod")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Hypatian Chronicle")]), _vm._v(", treating the northern and southern region best, respectively. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Nikonian Chronicle")]), _vm._v(" is a later work, merging the accounts of many chronicles into one continuous whole. It offers some information not found in the two earlier works."), _c('span', {
    staticClass: "super"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#note23",
      "id": "footnote23"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Central European Chronicles and sources:")]), _vm._v(" Julian, Thomas of Spalato, Rogerius, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Tartar Relation")]), _vm._v(", Carpini, and others wrote eyewitness accounts. There are also many preserved letters sent by kings and dignitaries. In addition there are various chroniclers."), _c('span', {
    staticClass: "super"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#note24",
      "id": "footnote24"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In general, the sources on Genghis Khan are weaker the earlier the period. For Sübe’etei the sources are weak when he operated far away from Han China, Persia, or Europe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many modern historians have helped to make great progress regarding use of these sources and in developing an improved understanding of the period. They face a serious challenge, having to master Mongolian, Chinese, and many other languages. Paul Pelliot, Louis Hambis, Erich Haenisch, Francis W. Cleaves, Paul Ratchnevsky, Igor de Rachewiltz, Thomas Allsen, Paul Buell, Ruth Dunnell, and Christopher "), _c('a', {
    attrs: {
      "id": "pagexvii"
    }
  }, [_vm._v("Atwood are some of the important historians. For the Near East and Europe important translators and historians consulted include H. G. Raverty, V. V. Barthold, J. A. Boyle, W. M. Thackston, D. S. Richards, T. Bedrosian, J. Fennell, Martin Dimnik, and G. Strakosch-Grassmann. The only militarily focussed broader narrative of value is that of Desmond Martin. Helped by Chinese scholars, he drew on a large base of Chinese sources and developed a very detailed description of Mongol operations in China from 1209 to 1227.")])]), _c('a', {
    attrs: {
      "id": "pagexvii"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Geographical locations in Mongolia are often hard to place. The views of Pelliot and de Rachewiltz are almost always followed in this study. There are many opposing views. For these the readers are referred to the commentary of de Rachewiltz on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Secret History.")]), _vm._v(" For locations in China reliance has been put on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Historical Atlas of China")]), _vm._v(", volume VI. The book "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Sino-Western calendar for two thousand years 1–2000 A.D.")]), _vm._v(" by Zhongsan Xue and Yi Ouyang has been used to convert traditional Chinese dates to modern Western ones.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-t1"
  }, [_vm._v("Translations used for primary key sources quoted in the text:")]), _vm._v(" "), _c('table', {
    staticClass: "table11"
  }, [_c('colgroup', [_c('col', {
    staticClass: "a50"
  }), _vm._v(" "), _c('col', {
    staticClass: "a50"
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "td"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Secret History")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Igor de Rachewiltz (2004)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_vm._v("SWQZL")]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Paul Pelliot and Louis Hambis (1951)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("John Emerson (website)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Yuanshi")]), _vm._v(" 1")]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("F. E. A. Krause (1922)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Yuanshi")]), _vm._v(" 2")]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Waltraut Abramowski (1978)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_vm._v("Yuan Shi 123/Sube’etei")]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Paul Buell (Nomads of Eurasia syllabus)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_vm._v("Rashid al-Din")]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("W. M. Thackston (1998-1999)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_vm._v("Juvaini")]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("John Andrew Boyle (1958)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_vm._v("Ibn al-Athir")]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("D. S. Richards (2008)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_vm._v("Nasawi")]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("O. Houdas (1895)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_vm._v("Juzjani")]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("H. G. Raverty (1895)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Chronicle of Novgorod")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("R. Mitchell and N. Forbes (1914)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Galician–Volynian Chronicle")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("George A. Perfecky (1973)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_vm._v("Roger")]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("J. M. Bak and M. Rady (2010)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_vm._v("Carpini")]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Erik Hildinger (1996)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Tartar Relation")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("R. A. Skelton (1965)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  })]), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "pagexvii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#footnote10",
      "id": "note10"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "foot-sp"
  }, [_vm._v("Christopher Atwood, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Encyclopedia of Mongolia and the Mongol Empire")]), _vm._v(" (New York: Facts on File, 2004), p.98.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#footnote11",
      "id": "note11"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "foot-sp"
  }, [_vm._v("Igor de Rachewiltz, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Secret History of the Mongols: A Mongolian Epic Chronicle of the Thirteenth Century")]), _vm._v(" (Leiden: E. J. Brill, 2004); Francis W. Cleaves, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Secret History of the Mongols")]), _vm._v(" (Cambridge, Mass.: Harvard University Press, 1982); Paul Pelliot, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Histoire Secrète des Mongols")]), _vm._v(" (Paris: Libraire d’Amérique et d’Orient, 1949).")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#footnote12",
      "id": "note12"
    }
  }, [_vm._v("3")]), _c('span', {
    staticClass: "foot-sp"
  }, [_vm._v("SWQZL in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Meng-ku shih liao ssu chung")]), _vm._v(", editor Wang Kuo-wei; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Histoire des campagnes de Gengis Khan – Cheng-wou ts’in-tcheng")]), _vm._v(", translated and commented by Paul Pelliot and Louis Hambis (Leiden: E. J. Brill, 1951); "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sheng Wu Jin Cheng Lu: Partial translation, comments and notes, translated by John Emerson")]), _vm._v("; and ‘Die letzen Feldzüge Cinggis Han’s und sein Tod’, translated by Erich Haenisch, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Asia Minor")]), _vm._v(" 9, pp.503–551. For a discussion of the source, see Christopher Atwood, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary of Shenwu qinzhenglu.")])])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#footnote13",
      "id": "note13"
    }
  }, [_vm._v("4")]), _c('span', {
    staticClass: "foot-sp"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Yuanshi")]), _vm._v(", editor Song Lian; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yuanshi")]), _vm._v(" 1, F. E. A. Krause, Cingis Han; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Die Geschichte seines Lebens nach den chinesischen Reichannalen")]), _vm._v(" (Heidelberg: C. Winter, 1922); "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yuanshi")]), _vm._v(" 2, Waltraut Abramowski, ‘Die Chinesischen Annalen von Ögödei und Güyük’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Zentral Asiatische Studien")]), _vm._v(" 10 (Wiesbaden, 1976); "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yuanshi")]), _vm._v(" 98 and 99, Ch’i-ch’ing Hsiao, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Military Establishment of the Yuan Dynasty")]), _vm._v(" (Cambridge, Mass.: Harvard University Press, 1978). Antony Gaubil translated some of the material, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Histoire de Gentchiscan et toute la dynastie des Mongols … tirée de l’histoire chinoise")]), _vm._v(" (Paris: Briasson, 1739). In the text, references are given to Krause and Abramowski for respectively "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yuanshi")]), _vm._v(" 1 and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yuanshi")]), _vm._v(" 2. All others are to the Chinese text of Song Lian. Paul Buell has a translation of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yuanshi")]), _vm._v(" 121 in his Nomads of Eurasia syllabus (part B); A. Remusa, ‘Souboutai’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nouveaux melagnes asiatiques")]), _vm._v(", volume 2 (Paris, 1829), pp.89–97, offers an early translation of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yuanshi")]), _vm._v(" 121.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#footnote14",
      "id": "note14"
    }
  }, [_vm._v("5")]), _c('span', {
    staticClass: "foot-sp"
  }, [_vm._v("Rashid al-Din, Rashiduddin Fazlullah’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jam’u’t-tawarikh")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Compendium of Chronicles)")]), _vm._v(", translated by W. M. Thackston (Cambridge, Mass.: Harvard University Press, 1998–99).")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#footnote15",
      "id": "note15"
    }
  }, [_vm._v("6")]), _c('span', {
    staticClass: "foot-sp"
  }, [_vm._v("Tuotuo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jinshi")]), _vm._v(", and C. de Harlez, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Histoire de l’Empire de Kin; Ou, Empire d‘Or Aisin Gurun-I Suduri Bithe")]), _vm._v(" (Louvain: Typ. de C. Peeters, 1887), offer a summarised translation of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jinshi")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#footnote16",
      "id": "note16"
    }
  }, [_vm._v("7")]), _c('span', {
    staticClass: "foot-sp"
  }, [_vm._v("Tuotuo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Songshi")]), _vm._v("; Peter Olbricht and Elisabeth Pinks, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Meng-Ta Pei-Lu und Hei-ta Shih-Lüeh")]), _vm._v(" (Wiesbaden: Harrassowitz, 1980); Mi Zhou, "), _c('img', {
    attrs: {
      "alt": "figure",
      "src": "images/inxv-1.jpg"
    }
  }), _vm._v(", Qidong yeyu "), _c('img', {
    attrs: {
      "alt": "figure",
      "src": "images/inxv-2.jpg"
    }
  }), _vm._v(", pp.77–80.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#footnote17",
      "id": "note17"
    }
  }, [_vm._v("8")]), _c('span', {
    staticClass: "foot-sp"
  }, [_vm._v("Wang, Yun, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wuliang shi xian miao bei ming "), _c('img', {
    attrs: {
      "alt": "figure",
      "src": "images/inxv-3.jpg"
    }
  }), _vm._v(", Qiuqian xianshengdaquan wenji "), _c('img', {
    attrs: {
      "alt": "figure",
      "src": "images/inxv-4.jpg"
    }
  }), _c('img', {
    attrs: {
      "alt": "figure",
      "src": "images/inxv-5.jpg"
    }
  }), _vm._v(".")])])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#footnote18",
      "id": "note18"
    }
  }, [_vm._v("9")]), _c('span', {
    staticClass: "foot-sp"
  }, [_vm._v("Juvaini, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The History of the World-Conquerer")]), _vm._v(", translated by John Andrew Boyle (Manchester: Manchester University Press, 1958).")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#footnote19",
      "id": "note19"
    }
  }, [_vm._v("10")]), _c('span', {
    staticClass: "foot-sp1"
  }, [_vm._v("Ibn al-Athir, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Chronicle of Ibn al-Athir for the Crusading Period from al-Kamil fi’il-ta’rikh")]), _vm._v(", translated by D. S. Richards (Aldershot: Ashgate, 2008).")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#footnote20",
      "id": "note20"
    }
  }, [_vm._v("11")]), _c('span', {
    staticClass: "foot-sp1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Histoire du sultan Djelal ed-Din Mankobirti prince du Kharezm par Mohammed en-Nesawi")]), _vm._v(", translated by O. Houdas (Paris: E. Leroux, 1895).")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#footnote21",
      "id": "note21"
    }
  }, [_vm._v("12")]), _c('span', {
    staticClass: "foot-sp1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Tabakat-i-Nasiri of Minhaj-i-Saraj, Abu-Umar-i-Usman: A general history of the Muhammadan dynasties of Asia, including Hindustan from A.H. 194 (810 A.D.) to A.H. 658 (1260 A.D.), and the irruption of the infidel Mughals into Islam")]), _vm._v(". Translator H. G. Raverty made an extensive commentary, including a summary of many other Persian sources that wrote about events (Calcutta: The Asiatic Society, 1895).")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#footnote22",
      "id": "note22"
    }
  }, [_vm._v("13")]), _c('span', {
    staticClass: "foot-sp1"
  }, [_vm._v("Robert P. Blake and R. N. Frye, ‘Grigor Aknerc’i: History of the Nation of the Archers’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Harvard Journal of Asiatic Studies")]), _vm._v(", 3–4, pp.269–443; Kirakos Ganjaketets’i: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("History of the Armenians")]), _vm._v(", Robert Bedrosian (1986), "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://rbedrosian.com/kg1.htm",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("http://rbedrosian.com/kg1.htm")])])]), _vm._v("; Vardan Arewelc’I: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Compilation of History")]), _vm._v(", Robert Bedrosian (2007), "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://rbedrosian.com/vaint.htm",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("http://rbedrosian.com/vaint.htm")])])]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#footnote23",
      "id": "note23"
    }
  }, [_vm._v("14")]), _c('span', {
    staticClass: "foot-sp1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Chronicle of Novgorod")]), _vm._v(", translated by R. Mitchell and N. Forbes (London: Camden Society, 1914); "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Hypatian Chronicle: The Galician–Volynian Chronicle")]), _vm._v(", translated by George A. Perfecky (München: W. Fink, 1973); "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Nikonian Chronicle")]), _vm._v(", translated by Serge A. Zenkovsky and Betty Jean Zenkovsky (Princeton: Kingston Press, vols. 2 and 3).")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#footnote24",
      "id": "note24"
    }
  }, [_vm._v("15")]), _c('span', {
    staticClass: "foot-sp1"
  }, [_vm._v("János M. Bak and Martin Rady, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anonymus and Master Roger")]), _vm._v(" (Budapest, 2010); Maurice Michael and Paul Smith, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Annals of Jan Długosz")]), _vm._v(": "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A History of Eastern Europe 965 to 1480")]), _vm._v(" (Charlton, West Sussex: IM Publications, 1997); Giovanni da Pian del Carpini, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The story of the Mongols whom we call Tartars")]), _vm._v(", translated by Erik Hildinger (Boston: Branden Publishing Company, 1996); Christopher Dawson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Mongol Mission")]), _vm._v(" (London: Sheed and Ward, 1955); R. A. Skelton, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Vinland Map and the Tartar relation")]), _vm._v(" (New Haven: Yale University Press, 1965); Shinobu Iwamura, ‘Mongol invasion of Poland in the Thirteenth Century’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Memoirs of the Research Department of the Toyo Bunko")]), _vm._v(" (Tokyo, 1938); Hansgerd Göckenjan and James Sweeney, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Der Mongolensturm: Berichte von Augenzeugen und Zeitgenossen, 1235–1250")]), _vm._v(" (Graz: Styria, 1985); "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Monumenta Germaniae Historica")]), _vm._v(" (Hanover and Berlin, 1826+).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efd427e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Note_on_Sources.vue
// module id = 75
// module chunks = 0